import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  style: {"display":"block","transform":"scale(-1,1)"}
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.592 12.925h-3.775a.833.833 0 0 0 0 1.667h2A6.667 6.667 0 0 1 3.333 10a.833.833 0 0 0-1.666 0 8.333 8.333 0 0 0 14.066 6.025V17.5a.833.833 0 0 0 1.667 0v-3.75a.833.833 0 0 0-.808-.825M10 1.667a8.33 8.33 0 0 0-5.733 2.308V2.5a.833.833 0 1 0-1.667 0v3.75a.833.833 0 0 0 .833.834h3.75a.833.833 0 1 0 0-1.667h-2A6.667 6.667 0 0 1 16.667 10a.833.833 0 0 0 1.666 0A8.335 8.335 0 0 0 10 1.667"
    }, null, -1)
  ])))
}
export default { render: render }